<template>
  <v-slide-group class="smoothScrollContainer" :model-value="undefined" :mandatory="false" :multiple="false">
    <slot></slot>
  </v-slide-group>
</template>

<script>
export default {
  name: 'SmoothScrollContainer'
};
</script>
